import { SharedModule } from "app/shared.module";
import { NgModule } from "@angular/core";
import { PriceInput, NewspotProductsComponent } from "app/newspot-products/newspot-products.component";
import { NewSpotComponent } from "./newspot.component";
import { NewspotImagesComponent } from "app/newspot-images/newspot-images.component";
import { NewspotSurveyComponent } from "app/newspot-survey/newspot-survey.component";
import { NewspotSuccessComponent } from "app/newspot-success/newspot-success.component";
import { NgxCurrencyModule } from "ngx-currency";
import { SyncBarModule } from "app/sync-bar/sync-bar.module";
import { NewspotErrorComponent } from "app/newspot-error/newspot-error.component";


@NgModule({
    declarations: [
        NewSpotComponent,
        NewspotImagesComponent,
        NewspotSurveyComponent,
        NewspotProductsComponent,
        NewspotSuccessComponent,
        NewspotErrorComponent,
        PriceInput,
    ],
    imports: [
        SharedModule,
        NgxCurrencyModule,
        SyncBarModule
    ]
})

export class NewspotModule {
}
